import n from "react";
import { css as r, cx as e } from "@leafygreen-ui/emotion";
import o from "prop-types";
import t from "@leafygreen-ui/box";
import { isComponentType as a } from "@leafygreen-ui/lib";
import { useUsingKeyboardContext as i } from "@leafygreen-ui/leafygreen-provider";
import { palette as l, uiColors as c } from "@leafygreen-ui/palette";
import { isComponentGlyph as s } from "@leafygreen-ui/icon";
import { validateAriaLabelProps as f } from "@leafygreen-ui/a11y";
import { jsx as b } from "@emotion/react";

function u(n, r) {
  var e = Object.keys(n);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), e.push.apply(e, o);
  }

  return e;
}

function g(n) {
  for (var r = 1; r < arguments.length; r++) {
    var e = null != arguments[r] ? arguments[r] : {};
    r % 2 ? u(Object(e), !0).forEach(function (r) {
      d(n, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : u(Object(e)).forEach(function (r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }

  return n;
}

function d(n, r, e) {
  return r in n ? Object.defineProperty(n, r, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[r] = e, n;
}

function p() {
  return p = Object.assign || function (n) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];

      for (var o in e) {
        Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
      }
    }

    return n;
  }, p.apply(this, arguments);
}

function y(n, r) {
  if (null == n) return {};

  var e,
      o,
      t = function (n, r) {
    if (null == n) return {};
    var e,
        o,
        t = {},
        a = Object.keys(n);

    for (o = 0; o < a.length; o++) {
      e = a[o], r.indexOf(e) >= 0 || (t[e] = n[e]);
    }

    return t;
  }(n, r);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(n);

    for (o = 0; o < a.length; o++) {
      e = a[o], r.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(n, e) && (t[e] = n[e]);
    }
  }

  return t;
}

function h(n, r) {
  return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}

var m,
    k,
    v,
    O,
    w,
    j,
    x,
    P,
    S,
    z,
    D,
    N,
    I,
    C,
    E,
    L,
    M,
    B,
    X,
    K = ["size", "darkMode", "disabled", "active", "className", "children"],
    R = "light",
    T = "dark",
    q = {
  Default: "default",
  Large: "large",
  XLarge: "xlarge"
},
    A = r(m || (m = h(["\n  border: none;\n  -webkit-appearance: unset;\n  padding: unset;\n"]))),
    F = r(k || (k = h(["\n  display: inline-block;\n  border-radius: 100px;\n  position: relative;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: 150ms ease-in-out;\n  transition-property: color, box-shadow;\n\n  // Set background to fully-transparent white for cross-browser compatability with Safari\n  //\n  // Safari treats \"transparent\" values in CSS as transparent black instead of white\n  // which can make things render differently across browsers if not defined explicitly.\n  background-color: rgba(255, 255, 255, 0);\n\n  &:before {\n    content: '';\n    transition: 150ms all ease-in-out;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    border-radius: 100%;\n    opacity: 0;\n    transform: scale(0.8);\n  }\n\n  &:active:before,\n  &:hover:before,\n  &:focus:before {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  &:focus {\n    outline: none;\n  }\n"]))),
    G = (d(j = {}, q.Default, r(v || (v = h(["\n    height: 28px;\n    width: 28px;\n  "])))), d(j, q.Large, r(O || (O = h(["\n    height: 36px;\n    width: 36px;\n  "])))), d(j, q.XLarge, r(w || (w = h(["\n    height: 42px;\n    width: 42px;\n  "])))), j),
    H = (d(S = {}, R, r(x || (x = h(["\n    color: ", ";\n\n    &:active,\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), l.gray.base, l.gray.dark3, l.gray.light2)), d(S, T, r(P || (P = h(["\n    color: ", ";\n\n    &:active,\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), c.gray.base, c.white, c.gray.dark2)), S),
    J = (d(N = {}, R, r(z || (z = h(["\n    &:focus {\n      color: ", ";\n      box-shadow: 0 0 0 2px ", ", 0 0 0 4px ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), l.gray.dark3, l.white, l.blue.light1, l.gray.light2)), d(N, T, r(D || (D = h(["\n    &:focus {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), c.blue.light1, c.blue.dark2)), N),
    Q = (d(E = {}, R, r(I || (I = h(["\n    cursor: not-allowed;\n    color: ", ";\n    background-color: rgba(255, 255, 255, 0);\n\n    &:active,\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: rgba(255, 255, 255, 0);\n      }\n    }\n\n    &:focus {\n      color: ", ";\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), l.gray.light1, l.gray.light1, l.gray.light1, l.gray.light3)), d(E, T, r(C || (C = h(["\n    cursor: not-allowed;\n    color: ", ";\n    background-color: rgba(255, 255, 255, 0);\n\n    &:active,\n    &:hover {\n      color: ", ";\n\n      &:before {\n        background-color: rgba(255, 255, 255, 0);\n      }\n    }\n\n    &:focus {\n      color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  "])), c.gray.dark2, c.gray.dark2, c.gray.dark2, c.gray.dark1)), E),
    U = (d(B = {}, R, r(L || (L = h(["\n    color: ", ";\n    background-color: ", ";\n\n    &:before {\n      background-color: ", ";\n    }\n  "])), c.gray.dark2, c.gray.light2, c.gray.light2)), d(B, T, r(M || (M = h(["\n    color: ", ";\n    background-color: ", ";\n\n    &:before {\n      background-color: ", ";\n    }\n  "])), c.white, c.gray.dark2, c.gray.dark2)), B),
    V = r(X || (X = h(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]))),
    W = n.forwardRef(function (r, o) {
  var l,
      c,
      u = r.size,
      h = void 0 === u ? q.Default : u,
      m = r.darkMode,
      k = void 0 !== m && m,
      v = r.disabled,
      O = void 0 !== v && v,
      w = r.active,
      j = void 0 !== w && w,
      x = r.className,
      P = r.children,
      S = y(r, K),
      z = k ? "dark" : "light",
      D = i().usingKeyboard;
  f(S, "IconButton");
  var N = n.Children.map(P, function (r) {
    if (!r) return null;

    if (a(r, "Icon") || s(r)) {
      var e = r.props,
          o = e.size,
          t = e.title,
          i = {
        size: o || h
      };
      return "string" == typeof t && 0 !== t.length || (i.title = !1), n.cloneElement(r, i);
    }

    return r;
  }),
      I = g(g({}, S), {}, (d(c = {
    ref: o,
    tabIndex: 0
  }, "aria-disabled", O), d(c, "href", O ? void 0 : S.href), d(c, "onClick", O ? void 0 : S.onClick), d(c, "className", e(A, F, G[h], H[z], (d(l = {}, J[z], D), d(l, U[z], j), d(l, Q[z], O), l), x)), c));
  return "string" == typeof S.href ? b(t, p({
    as: "a"
  }, I), b("div", {
    className: V
  }, N)) : b(t, p({
    as: "button"
  }, I), b("div", {
    className: V
  }, N));
});
W.displayName = "IconButton", W.propTypes = {
  darkMode: o.bool,
  size: o.oneOf(Object.values(q)),
  className: o.string,
  children: o.node,
  disabled: o.bool,
  href: o.string,
  active: o.bool
};
export { q as Size, W as default };